import { reportError } from '@pypestream/utils';

/**
 * Reports a boot-time failure the user meets as a wall.
 *
 * `resolveSessionAtBoot` answers `unknown` when Kratos cannot be reached at all
 * — offline, DNS, CORS, timeout — and this module turns that into a full-screen
 * "We couldn't verify your session". PSTUDIO-4022 made `unknown` deliberately
 * NOT a sign-out, which is right, but it also left the state unobservable: the
 * user is stuck and nothing records it.
 *
 * This runs at module scope, BEFORE `Sentry.init` has been called — the gate
 * waits for LaunchDarkly first. `reportError` degrades to a no-op without a
 * client, so an early failure is lost rather than queued. Stated rather than
 * implied: what this catches reliably is a session that fails later in the
 * boot, not one that fails in the first milliseconds.
 */
export const reportBootFailure = (error: unknown, source: string): void => {
  try {
    reportError(error, { source, tags: { app: 'manager' } });
  } catch {
    // Deliberately empty: the retry screen below matters more than the report.
  }
};
